export default "__VITE_ASSET__VtV6X3v8__"